import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import Land from "./landing-page/LandingPage.tsx";
import { IntlProviderWrapper } from "./landing-page/components/IntlProviderWrapper.tsx";
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(  
<React.StrictMode>
<IntlProviderWrapper>
{/* <IntlProvider locale={navigator.language} messages={selectMessages()}> */}
  <Land /> 
  {/* </IntlProvider> */}
 </IntlProviderWrapper> 
</React.StrictMode>,);